import { paramParsers, StringParamParser } from './param-parsers';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
type HandlersFromValues<Values extends Record<string, any | undefined>> = {
    [Prop in keyof Values]: StringParamParser<Values[Prop]>;
};

type StringParams<T extends Record<string, any>> = {
    [Prop in keyof T]: string | undefined;
};

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export class UrlParamsHandler<Values extends Record<string, any | undefined>> {
    static readonly parserString = paramParsers.uri;
    static readonly parserNumber = paramParsers.number;

    constructor(private parsers: HandlersFromValues<Values>) {}

    static from<T extends Record<string, any>>(parsers: HandlersFromValues<T>) {
        return new UrlParamsHandler<T>(parsers);
    }

    toString(values?: Partial<Values>): Partial<StringParams<Values>> {
        const params: Partial<StringParams<Values>> = {};

        if (!values) {
            return params;
        }

        for (const key of Object.keys(values) as (keyof Values)[]) {
            const parser = this.parsers[key];

            if (!parser) {
                continue;
            }

            const value = values[key];

            if (value !== undefined) {
                params[key] = parser.stringify(value!);
            }
        }

        return params;
    }

    parse(params: StringParams<Values>): Partial<Values> {
        const values: Partial<Values> = {};

        for (const key of Object.keys(params) as (keyof Values)[]) {
            const parser = this.parsers?.[key];

            if (!parser) {
                continue;
            }

            const value = params[key];

            if (value !== undefined) {
                values[key] = parser.parse(value);
            }
        }

        return values;
    }
}
